export const TRANSLATION_LOADING = "TRANSLATION_LOADING";
export const TRANSLATION_ADD = "TRANSLATION_ADD";
export const TRANSLATION_DELETE = "TRANSLATION_DELETE";
export const TRANSLATION_FILTERS = "TRANSLATION_FILTERS";
export const TRANSLATION_LIST = "TRANSLATION_LIST";



// WEBPACK FOOTER //
// ./src/actions/translation/types.js